import {Routes} from '@angular/router';
import {UnespCoreAccessDeniedComponent, UnespCoreHomeComponent, UnespCorePageNotFoundComponent} from '@unesp/core';
import {HomeComponent} from './modules/home/home.component';
import {CentralComponent} from "./central.component";

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'eleicoes',
    loadChildren: () =>
      import('./modules/eleicoes/eleicoes.routes').then((r) => r.ELEICOES_ROUTES)
  },
  {
    path: 'candidatos',
    loadChildren: () =>
      import('./modules/candidatos/candidatos.routes').then((r) => r.CANDIDATOS_ROUTES)
  },
  {
    path: 'esu',
    loadChildren: () =>
      import('./modules/esu/esu.routes').then((r) => r.ESU_ROUTES)
  },
  {
    path: 'central',
    component: CentralComponent
  },
  {
    path: 'access-denied',
    component: UnespCoreAccessDeniedComponent,
  },
  {
    path: 'auth',
    component: UnespCoreHomeComponent,
  },
  {
    path: 'page-not-found',
    component: UnespCorePageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '/page-not-found',
  },
];
